import { getStrings } from '../../../Common/Localization/commonStrings';

const localizedStrings = {
  MFAOptions: {
    strings: {
      en: {
        heading: 'Enable MFA',
        content: `Enabling multi-factor authentication (MFA) safeguards your account in
        the event your User ID or password is compromised. This quick and easy
        method adds an extra layer of security to protect your confidential data
        from hackers and cyber threats.`,
        optInQuestion: 'Would you like to opt-in to MFA?',
        optInButton: 'Opt-in',
        remindMeLaterButton: 'Remind Me Later',
        neverAskAgainButton: 'Never Ask Again'
     }
    },
  },
  TurnOnMFA : {
    strings: {
      en: {
        globalError: 'We’re having some technical issues. Please try again later.',
        fromPaymentMessage: 'To ensure your account’s security, we will send a verification code to a phone number we have on file. Please select a phone number.',
        phoneMessage: 'Select or add a phone number you have access to for multi-factor authentication (MFA).',
        sendOTPMessage: 'Each time you sign in, a code will be sent to this phone number to ensure your account remains secure.',
        newPhoneNumber: 'Enter the new phone number you would like to add to your account.',
        radioMessage: 'How would you like to receive the code?',
        textMe: ' Text me',
        callMe: ' Call me',
        otpOptionMessage: 'Don’t want to use your phone number?',
        emailOtpMessage: 'To continue we need to verify you are an authorized user. We will send a verification code to your email ID.',
        profileMessage: 'If you would like to use voice or text, enable multi-factor authentication in your ',
        profileSettings: 'profile settings.',
        emailOTP: 'Receive code by email',
        emailSendCode: 'Receive Code By Email',
        sendCode: 'Send Code',
        cancel: 'Cancel',
        verificationHeading: 'Code Sent to Number Ending in',
        verifyEmailHeading: 'Code Sent to Email',
        enterCode: 'Enter your Verification Code',
        verifyButton: 'Verify',
        anotherCode: 'Didn’t receive a code or need another?',
        resend: 'Resend code',
        differentMethod: 'Choose a different method',
        successHeading: 'MFA Opt-In Successful',
        successContent: 'You have successfully enabled MFA for your phone number ending in',
        mfaUpdatedHeading: 'Multi-factor Authentication Updated',
        mfaUpdatedContent: 'will now be used to verify your identity.',
        mfaTurnOffHeading: 'MFA Turned Off',
        mfaTurnOffContent: 'You have successfully turned off MFA for your account.',
        sendCodeGeneralError: 'Something went wrong on our end. Please click "Resend Code" for a new code to be sent to your device. We appreciate your patience.',
        sendCodeWaitError: 'We were unable to resend your code. Please try again in 1 minute.',
        E0000001: 'It looks like the code you’ve entered may have expired or is incorrect. Click "Resend Code" for a new code to be sent to your device.',
        E0000004: 'It looks like the code you’ve entered may have expired or is incorrect. Click "Resend Code" for a new code to be sent to your device.',
        E0000007: 'It looks like the code you’ve entered may have expired or is incorrect. Click "Resend Code" for a new code to be sent to your device.',
        OKTA_E0000068: 'It looks like the code you’ve entered may have expired or is incorrect. Click "Resend Code" for a new code to be sent to your device.',
        OKTA_E0000069: 'We have locked your account due to too many attempts to Log in. Please reset your password.',
        OKTA_E0000047: 'The Verify pin option has been temporarily disabled due to multiple invalid attempts.',
        default: 'Something went wrong on our end. Please click "Resend Code" for a new code to be sent to your device. We appreciate your patience.',
      }
    },
  },
  NeverAskAgain: {
    strings: {
      en: {
        heading: 'Thank you for your selection',
        content: 'You have chosen to opt out of receiving further prompts about multi-factor authentication (MFA).',
        continue: 'Continue',
      }
    },
  },
  LoginMFA: {
    strings: {
      en: {
        heading: 'Multi-factor Authentication',
        content: 'How would you like to receive your code to your phone number ending in ',
        textMe: ' Text me',
        callMe: ' Call me',
        phoneQuestion: 'Don’t want to use your phone number?',
        emailOTP: 'Receive code by email',
        sendCode: 'Send Code',
        cancel: 'Cancel',
        verifyPhoneHeading: 'Code Sent to Number Ending in',
        verifyEmailHeading: 'Code Sent to Email',
        enterCode: 'Enter your Verification Code',
        verify: 'Verify',
        anotherCode: 'Didn’t receive a code or need another?',
        resend: 'Resend code',
        differentMethod: 'Choose a different method',
        verifyError: 'It looks like the code you’ve entered may have expired or is incorrect. Click "Resend Code" for a new code to be sent to your device.',
        sendCodeGeneralError: 'Something went wrong on our end. Please click "Resend Code" for a new code to be sent to your device. We appreciate your patience.',
        sendCodeWaitError: 'We were unable to resend your code. Please try again in 1 minute.',
      }
    },
  },
  MFAStatusCard:{
    strings:{
      en: {
        verification: 'MFA Verification',
        content: 'Multi-factor authentication(MFA) is a quick and simple way to add an extra layer of protection to confidential data',
        status: 'MFA Status: ',
        on: 'ON',
        off: 'OFF',
        edit: 'Edit',
        optOut: 'Opt Out of MFA',
        optOutContent: 'You have chosen to turn off MFA. Turning off MFA removes the extra layer of security to your account.',
        optOutQuestion: 'Are you sure you want to turn off MFA?',
        yes: 'Yes',
        cancel: 'Cancel',
        detailedContent: 'Multi-factor authentication (MFA) enhances the security of your account. Each time you log in, a code will be sent to your phone number, serving as an extra layer of protection in case your user ID/password is compromised.',
        turn: 'Turn',
        currentMethod: 'Current Methods',
        OneTimeCode: 'One-Time Code',
      }},
  }
};

export const getLocalizedStrings = (componentName) => {
    app.logger.getLogger().debug("Comp Name" + componentName);
    const strings = getStrings(localizedStrings[componentName].strings,
    localizedStrings[componentName].common, true);
  return strings;
};